import { useEffect, useState } from "react";
import { loadHomeEvents, HomeEvent, HomeEventTimeFilter, HomeEventFeedOptions } from "../utils/home-event-feed";

export type { HomeEvent } from "../utils/home-event-feed";

export default function useHomeEvents(country: string, timeFilter?: HomeEventTimeFilter, options: HomeEventFeedOptions & { enabled?: boolean } = {}) {
  const { limit = 10, enabled = true } = options;
  const excludedIds = JSON.stringify(options.excludeEventIds || []);
  const requestKey = JSON.stringify([country, timeFilter, limit, excludedIds]);
  const [state, setState] = useState<{ key: string; events: HomeEvent[]; loading: boolean; failed: boolean }>({ key: "", events: [], loading: true, failed: false });

  useEffect(() => {
    if (!enabled) return;
    const controller = new AbortController();
    setState({ key: requestKey, events: [], loading: true, failed: false });
    loadHomeEvents(country, timeFilter, controller.signal, { limit, excludeEventIds: JSON.parse(excludedIds) })
      .then(events => {
        if (controller.signal.aborted) return;
        setState({ key: requestKey, events, loading: false, failed: false });
      })
      .catch(() => {
        if (controller.signal.aborted) return;
        setState({ key: requestKey, events: [], loading: false, failed: true });
      });
    return () => controller.abort();
  }, [country, timeFilter, limit, enabled, excludedIds, requestKey]);

  return enabled && state.key === requestKey
    ? { events: state.events, loading: state.loading, failed: state.failed }
    : { events: [] as HomeEvent[], loading: true, failed: false };
}
